<template>
  <hic-dialog append-to-body @open="loadData" :close-on-click-modal="false" :title="title" :visible="visible" width="44rem" top="10vh" @close="close">
    <hic-print-simple :tmpl-code="tmplCode" :print-data="printData" ref="printer" :loading="loading">
      <template #tools>
        <b v-if="hospitalization" class="sub-title">{{ hospitalization.patientName }} {{ hospitalization.bedNo }}床 {{ hospitalization.patientAge }}</b>
        <br />
      </template>

      <el-radio-group v-if="type != '检验汇总单'" v-model="range" size="mini" @change="loadData" class="bottom-pad">
        <el-radio v-if="selected && selected.length" label="selected">选中项</el-radio>
        <el-radio label="all">全部</el-radio>
        <el-radio label="printable">未打印</el-radio>
        <el-radio label="condition">查询条件</el-radio>
      </el-radio-group>
    </hic-print-simple>

    <div slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {},
    props: {
      visible: Boolean,
      hospitalization: Object,
      selected: Array,
      type: String,
      condition: Object,
    },
    data() {
      return {
        loading: false,
        entities: {},
        con: {
          states: ["启用", "待停止", "停止"],
          sort: "adviceNo",
          asc: true,
        },
        printData: {},
        range: "all",
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission", "setting"]),
      tmplCode() {
        if (this.type == "口服") return "KouFuYaoDan";
        if (this.type == "检验汇总单") return "JianYanHuiZongDan";
        if (this.hospitalization) {
          if (this.type == "长期") return "ChangQiYiZhu";
          if (this.type == "临时") return "LinShiYiZhu";
        } else {
          if (this.type == "长期") return "ChangQiYiZhuLieBiao";
          if (this.type == "临时") return "LinShiYiZhuLieBiao";
        }
        return "";
      },
      title() {
        if (this.type == "口服") return "药品执行单";
        if (this.type == "长期") return "长期医嘱";
        if (this.type == "临时") return "临时医嘱";
        return this.type;
      },
    },
    methods: {
      open() {
        this.loadData();
      },
      close() {
        this.$emit("update:visible", false);
      },
      loadData() {
        if (this.type == "检验汇总单") {
          this.printData = {
            Master: {
              deptName: this.$utils.Dict.text(this.user.deptCode, "Dept"),
            },
            Detail: this.selected.map((item) => ({
              ...item,
              content: `${item.name} ${item.standard || ""}`,
              specimen: this.getSpecimen(item),
              patientAge: item.patient?.patientAge,
              patientGender: this.$utils.Dict.text(item.patient?.patientGender, "Gender"),
            })),
          };
          return;
        }
        if (this.range == "selected") {
          this.makePrintData(this.selected);
          return;
        }
        this.loading = true;
        let con = { ...this.con, hospitalizationId: this.hospitalization?.id };
        if (this.range == "printable") {
          con.ifPrint = false;
        } else if (this.range == "condition") {
          con = { ...this.condition };
        }
        con.pageSize = 99999999;
        if (this.type == "口服") {
          con.sort = "no";
          api.Advice.printDrug(con)
            .then((res) => {
              if (res.length) {
                this.printData = {
                  Master: {
                    deptName: this.$utils.Dict.text(this.hospitalization.deptCode, "Dept"),
                    ...this.hospitalization,
                    userName: this.user.name,
                  },
                  Detail: res.map((item) => ({
                    ...item,
                    stDt: this.$utils.Fmt.date(item.startTime),
                    edDt: this.$utils.Fmt.date(item.endTime),
                    execDt: this.$utils.Fmt.date(item.execTime),
                    dosageName: `${item.dosagePerTime || ""} ${item.dosageUnit || ""}`,
                    frequencyCode: this.getFrequencyName(item.frequency),
                    name: item.rpClass == '药品' || item.rpClass == '草药' ? item.name + ' ' + item.standard : item.name,
                  })),
                };
              } else {
                this.$message.warning("没有数据");
                this.printData = {
                  Master: {
                    deptName: this.user.deptName,
                    ...this.hospitalization,
                  },
                  Detail: [],
                };
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else if (this.type == "长期" || this.type == "临时" || this.type == "医嘱列表") {
          con.term = this.type;
          con.sort = "bedNo,id";
          con.ifMasterSlave = true;
          api.Advice.query(con)
            .then((res) => {
              if (!res.items.length) {
                this.$message.warning("没有数据");
              }
              this.makePrintData(res.items || []);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      },
      makePrintData(items) {
        this.printData = {
          Master: this.hospitalization
            ? {
                deptName: this.$utils.Dict.text(this.hospitalization.deptCode, "Dept"),
                ...this.hospitalization,
              }
            : null,
          Detail: items.map((item) => ({
            ...item,
            stDt: this.$utils.Fmt.date(item.issuedTime),
            stTm: this.$utils.Fmt.time(item.issuedTime),
            edDt: this.$utils.Fmt.date(item.stopTime),
            edTm: this.$utils.Fmt.time(item.stopTime),
            execTime: this.$utils.Fmt.datetime(item.execTime),
            startDoctorName: item.doctorName,
            startNurseName: item.execUserName,
            endDoctorName: item.stopDoctorName,
            endNurseName: item.stopNurseName,
            content: this.genContent(item),
            name: this.type == "口服" && (item.rpClass == '药品' || item.rpClass == '草药') ? item.name + ' ' + item.standard : item.name
          })),
        };
      },
      getFrequencyName(code) {
        let f = this.dict.DrugFrequency.find((item) => item.code == code);
        if (!f) {
          return code;
        }
        return f.shortCode;
      },
      genContent(item) {
        let content = "";
        if (item.rpClass == "药品") {
          content = `${item.name}${item.standard || ""} ${item.dosagePerTime || ""}${item.dosageUnit || item.minUnit || ""}/次 ${this.getFrequencyName(item.frequency) || ""}`;
        } else if (item.rpClass == "草药") {
          if (item.ifDetail) {
            content = `${item.name}${item.standard || ""} ${item.quantity || ""}${item.unit || ""}`;
          } else {
            content = `${item.name}${item.standard || ""} ${item.dosagePerTime || ""}${item.dosageUnit || item.minUnit || ""}/次 ${this.getFrequencyName(item.frequency) || ""}`;
          }
        } else {
          content = item.name;
        }

        if (item.items && item.items.length) {
          item.items.forEach((i) => {
            content += `，${this.genContent(i)}`;
          });
        }
        return content;
      },
      getSpecimen(item) {
        if (item.specimenType) {
          return this.$utils.Dict.text(item.specimenType, "SpecimenType");
        }
        if (item.detail) {
          try {
            let detail = JSON.parse(item.detail || "{}");
            return this.$utils.Dict.text(detail.specimenType, "SpecimenType");
          } catch (e) {
            console.log(e);
          }
        }
        return "";
      },
    },
  };
</script>
